import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';
import { ApiRoutes } from '../constants/api.routes';
import { ToastrService } from 'ngx-toastr';

const LOADER_EXCLUDED_URLS = [
  ApiRoutes.SEARCH_ADDRESS,
  ApiRoutes.GET_ADDRESS_BY_ADDRESS_ID,
  ApiRoutes.SEARCH_BUSINESS_DETAILS,
  ApiRoutes.GET_QUOTA_VERSION_BY_SEASON,
  ApiRoutes.GET_ORGANISATION_PLANT_PRODUCTION_HISTORY,
  ApiRoutes.GET_PRODUCT_TYPE_BY_QUOTA_ID,
  ApiRoutes.GET_DEPARTURE_SUGGESTIONS,
  ApiRoutes.GET_ARRIVAL_SUGGESTIONS,
  ApiRoutes.GET_QUOTA_VERSION_DROPDOWN,
  'auth0.com'
];

const SLOW_API_TOAST_URLS = [
  ApiRoutes.EXPORT_CERTIFICATE,
];

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoaderService);
  const toastr = inject(ToastrService);

  const skipLoader = LOADER_EXCLUDED_URLS.some(url =>
    req.url.includes(url)
  );

  const showSlowApiToast = SLOW_API_TOAST_URLS.some(url =>
    req.url.includes(url)
  );

  let timeoutId: ReturnType<typeof setTimeout> | undefined;
  let toastRef: any;

  if (!skipLoader) {
    loader.show();
  }

  if (showSlowApiToast) {
    timeoutId = setTimeout(() => {
      toastRef = toastr.warning(
        'Taking longer than usual. Please wait, this may take a few moments...',
        '',
        {
          disableTimeOut: true,
          tapToDismiss: false,
          closeButton: false
        }
      );
    }, 4000);
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipLoader) {
        loader.hide();
      }

      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      if (toastRef) {
        toastr.clear(toastRef.toastId);
      }
    })
  );
};
